import { useState, useEffect, useCallback } from 'react';
import { cursosService } from '../services/api';

export const CURSOS_DISPONIBLES_DASHBOARD_PATH = '/dashboard/cursos-disponibles';

export const notifyCursosDisponiblesChanged = () => {
  window.dispatchEvent(new CustomEvent('cursosDisponiblesRefresh'));
};

/** true si hay al menos un curso con inscripción abierta (solo consulta cuando enabled). */
export function useHayCursosDisponibles(enabled) {
  const [hayCursos, setHayCursos] = useState(false);
  const [loading, setLoading] = useState(!!enabled);

  const refresh = useCallback(() => {
    if (!enabled) {
      setHayCursos(false);
      setLoading(false);
      return Promise.resolve(false);
    }
    setLoading(true);
    return cursosService
      .getCursosDisponibles({ page: 1, page_size: 1 })
      .then(({ total }) => {
        const hay = total > 0;
        setHayCursos(hay);
        return hay;
      })
      .catch(() => {
        setHayCursos(false);
        return false;
      })
      .finally(() => setLoading(false));
  }, [enabled]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    const onRefresh = () => refresh();
    window.addEventListener('cursosDisponiblesRefresh', onRefresh);
    return () => window.removeEventListener('cursosDisponiblesRefresh', onRefresh);
  }, [refresh]);

  return { hayCursos, loading, refresh };
}

export function filterMenuCursosDisponibles(items, showCursosDisponibles) {
  if (showCursosDisponibles) return items;
  return items.filter((item) => item.path !== CURSOS_DISPONIBLES_DASHBOARD_PATH);
}
